
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { FormHeading } from "./FormHeading";

interface SizeFieldProps {
  form: UseFormReturn<any>;
  watchRequiresSize: boolean;
}

export const SizeField: React.FC<SizeFieldProps> = ({ form, watchRequiresSize }) => {
  if (!watchRequiresSize) return null;
  
  return (
    <FormField
      control={form.control}
      name="sizes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Sizes (comma separated or JSON)</FormLabel>
          <FormControl>
            <Input {...field} placeholder="S, M, L, XL or JSON object" />
          </FormControl>
          <FormMessage />
          <p className="text-sm text-muted-foreground">
            Example: S, M, L, XL or {"{ \"S\": \"Small\", \"M\": \"Medium\", \"L\": \"Large\" }"}
          </p>
        </FormItem>
      )}
    />
  );
};
